'use client';
import { FetchInsurerMinimalClaimDetailResponseBody } from 'bff';
import { isFraudLockedClaimStatusRole } from 'piramid-constants';
import React from 'react';
import { EnablementProvider } from '..';
import { EnablementAction } from '../contexts/EnablementContext';

// The customer claim payload (FetchClaimDetailResponseBody) does not carry the
// `claim_status` relation, so it's optional here: without it the fraud partial
// block simply never engages on that app — the backend guard still enforces it.
type EnablementClaim = Pick<
  FetchInsurerMinimalClaimDetailResponseBody,
  'system_status'
> & {
  claim_status?: Pick<
    FetchInsurerMinimalClaimDetailResponseBody['claim_status'],
    'role'
  > | null;
};

export const ClaimEnablementProvider = ({
  claim,
  children,
}: {
  claim: EnablementClaim;
  children: React.ReactNode;
}) => {
  const isClosed = claim.system_status === 'closed';
  const isFraudLocked = isFraudLockedClaimStatusRole(claim.claim_status?.role);

  // A closed claim is a full block. A fraud-locked (but still open) claim is a
  // partial block: everything is disabled except messaging, documentation and
  // reassigning the responsible (the activity section is not gated by this
  // provider, so it stays available on its own). `closed` takes priority — if
  // the claim is closed there are no exemptions.
  const exemptActions: ReadonlyArray<EnablementAction> =
    !isClosed && isFraudLocked
      ? ['messaging', 'documentation', 'claim_responsible']
      : [];

  return (
    <EnablementProvider
      reason={
        isClosed
          ? 'El reclamo se encuentra cerrado'
          : 'El reclamo está derivado a una investigación de fraude'
      }
      disabled={isClosed || isFraudLocked}
      exemptActions={exemptActions}
    >
      {children}
    </EnablementProvider>
  );
};
